import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Form,
  Image,
  Table,
  Button,
} from "react-bootstrap";
import LeftSideNavigation from "../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../navigationSection/RightSideNavigation";
import { TopNavigationBarMobile } from "../navigationSection/TopNavigationBarMobile";
import { IconButton } from "@material-ui/core";
import moment from "moment";
import { NEFT, serverApi } from "../../../config/Keys";
import InfoToolTip from "../../reusableComponents/InfoTooltipComponent";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { SmallLoader } from "../../../components/Loader/SmallLoader";
import { get_all_history_earnings } from "../../../store/actions/VendorEarnings/vendorEarningsActions";
import isEmpty from "../../../store/validation/is-Empty";
import {
  ORDER_TYPE,
  PAYMENT_TYPE,
  PAYMENT_STATUS,
} from "../../../enums/OrderEnums"; 
 
export const PayoutHistory = (props) => {
  const [state, setState] = useState(0);

  const dispatch = useDispatch();
  let history = useHistory();

  /**********************************
   * @DESC FIRST TIME API CALL
   *********************************/
  useEffect(() => {
    const token = props.auth.user.accessToken;
    const Id = history?.location?.state?.payoutId;
    dispatch(get_all_history_earnings(token, Id));
  }, []);

  /**************************************
   * @DESC SET ALL VENDOR EARNINGS DATA
   **************************************/
  const [vendorEarningsData, setVendorEarningsData] = useState([]);
  useEffect(() => {
    setVendorEarningsData(props.getAllVendorPayoutHistoryData);
  }, [props.getAllVendorPayoutHistoryData]);

  console.log(vendorEarningsData);

  return (
    <React.Fragment>
      <div className="container-fluid superadmin-orderscomponent-main super-admin-vendor-private-orders">
        <Row>
          <div className="left-side-panel">
            <LeftSideNavigation />
          </div>
          <div className="top-panel">
            <TopNavigationBarMobile displayLeft="logo" />
          </div>
          <div className="right-side-panel">
            <RightSideNavigation
              leftText="vendorReview"
              backButtonLink="/earnings"
              displayText="Back"
            />

            {/* <div className="col-12 pr-5">
              <div className="super_admin_add_vendor mb-4">
                <h5 className="main_header_text">Payout Details</h5>
              </div>
            </div> */}
            <div className="d-flex justify-content-between align-items-center pt-4">
              <div className="f24_700_HelveticaNeue">
                Payout Details
                <br />
              </div>
              <div>
                <div
                  align="right"
                  style={{ color: "#9E9E9E" }}
                  className="f10-400 my-2"
                >
                  Report Run Date: {moment().format("Do MMM, YYYY")}
                </div>
                <span
                  className="f12-400 text-grey"
                  style={{ color: "#9E9E9E" }}
                >
                  Report Range Date:
                </span>
                <span className="f12-500">
                  {" "}
                  {moment(vendorEarningsData?.payoutStartDate).format(
                    "Do MMM, YYYY"
                  )}{" "}
                  {"-"}{" "}
                  {moment(vendorEarningsData?.payoutEndDate).format(
                    "Do MMM, YYYY"
                  )}
                </span>
              </div>
            </div>

            <div className="mb-3 p-2">
              <hr />
              <Row>
                {/* <Col md={1}>
                  <div className="f14-500">Period</div>
                  <div className="f11-400 mt-3">
                    {moment(vendorEarningsData?.payoutStartDate).format(
                      "Do MMM YYYY"
                    )}
                  </div>
                  <div className="f11-400">
                    {moment(vendorEarningsData?.payoutEndDate).format(
                      "Do MMM YYYY"
                    )}
                  </div>
                </Col> */}
                <Col md={1}>
                  <div className="f14-500">Amount to be paid</div>
                  <div className="f11-400 mt-3">
                    ₹ {vendorEarningsData?.total_amount?.toFixed(2) || 0}
                  </div>
                </Col>
                <Col md={2}>
                  {vendorEarningsData?.payout_type === 0 ? (
                    <>
                      <div className="f14-500">
                        Current Settlement amount for Ordering
                      </div>
                      <div className="f11-400 mt-3">₹{" "}{vendorEarningsData?.settlement_amount?.toFixed(2)  || 0}</div>
                    </>
                  ) : vendorEarningsData?.payout_type === 2 ? (
                    <>
                      <div className="f14-500">
                        Amount to be Settled for Events
                      </div>
                      <div className="f11-400 mt-3">₹{" "}{vendorEarningsData?.settlement_amount?.toFixed(2)  || 0}</div>
                    </>
                  ) : (
                    <>
                      <div className="f14-500">Amount to be Settled </div>
                      <div className="f11-400 mt-3">-</div>
                    </>
                  )}
                </Col>
                <Col md={1}>
                  <div className="f14-500">Disputed Amount</div>
                  <div className="f11-400 mt-3">-</div>
                </Col>
                <Col md={1}>
                  <div className="f14-500">Payment Gateway</div>
                  <div className="f11-400 mt-3">{NEFT}</div>
                </Col>
                <Col md={1}>
                  <div className="f14-500">Commission</div>
                  <br />
                  <div className="f11-400 mt-2">
                    {" "}
                    ₹{" "}
                    {vendorEarningsData?.totalEarnedComission?.toFixed(2) || 0}
                  </div>
                </Col>
                <Col md={5}></Col>
                {/* <Col md={2}>
                  <div className="f12-500 badge badge-warning p-2 mt-4" style={{borderRadius:"50px"}}>
                    Open Items
                  </div>
                  </Col> */}
                <Col md={1}>
                  {vendorEarningsData?.settle_payment_status === 1 ? (
                    <div
                      style={{ borderRadius: "20px" }}
                      className="f12-500 badge badge-success p-2"
                    >
                      Settled
                    </div>
                  ) : (
                    <div
                      style={{ borderRadius: "20px" }}
                      className="f12-500 badge badge-warning p-2"
                    >
                      Unsettled
                    </div>
                  )}
                </Col>
              </Row>
              <hr />
            </div>
            <div>
              <div className="f14-700 mt-3  mb-3">Payable orders</div>
              <div className="d-flex">
                <div
                  className={`mr-5 ml-3 ${
                    state === 0 && `selected-global-catalogue `
                  } f12-500`}
                  onClick={() => setState(0)}
                  style={{ cursor: "pointer" }}
                >
                  {vendorEarningsData?.payout_type === 0
                    ? "orders"
                    : vendorEarningsData?.payout_type === 1
                    ? "orders"
                    : vendorEarningsData?.payout_type === 2
                    ? "Events"
                    : "Scan & pay"}
                </div>
                {/* <div
                  className={`mr-5 ml-3 ${
                    state === 1 && `selected-global-catalogue `
                  } f12-500`}
                  onClick={() => setState(1)}
                  style={{ cursor: "pointer" }}
                >
                  Events
                </div> */}
                {/* <div
                        className={`mr-5 ml-3 ${
                          state === 2 && `selected-global-catalogue `
                        } f12-500`}
                        onClick={() => setState(2)}
                        style={{ cursor: "pointer" }}
                      >
                        Scan & Pay
                      </div> */}
              </div>
            </div>
            <div>
              <div className="col-12 p-0 user-table-reusable-superadmin super-admin-all-vendor-main ">
                <Table>
                  <thead>
                    <TableHead
                      display={
                        vendorEarningsData?.payout_type === 0 ||
                        vendorEarningsData?.payout_type === 1 ? (
                          <tr>
                            <th style={{ width: "12%" }} className="f12-500">
                              Order Type/ <br />
                              Order ID
                            </th>
                            <th style={{ width: "12%" }} className="f12-500">
                              Subtotal <br /> Of Items
                            </th>
                            <th style={{ width: "12%" }} className="f12-500">
                              Discount
                            </th>
                            <th style={{ width: "12%" }} className="f12-500">
                              Net Order <br /> Value
                            </th>
                            <th style={{ width: "12%" }} className="f12-500">
                              Taxes
                            </th>
                            <th style={{ width: "12%" }} className="f12-500">
                              Surcharges
                            </th>
                            <th style={{ width: "12%" }} className="f12-500">
                              Tip
                            </th>
                            <th style={{ width: "12%" }} className="f12-500">
                              Amount <br />
                              Paid
                            </th>
                            <th style={{ width: "12%" }} className="f12-500">
                              Outgoing <br /> Charges + GST
                            </th>
                            <th style={{ width: "12%" }} className="f12-500">
                              Commission <br />+ GST
                            </th>
                            <th style={{ width: "12%" }} className="f12-500">
                              Amount to
                              <br /> be Settled
                            </th>
                          </tr>
                        ) : null
                      }
                      displayevents={
                        vendorEarningsData?.payout_type === 2 ? (
                          <tr>
                            <th style={{ width: "14%" }} className="f12-500">
                              Event/ Event ID/
                              <br />
                              Event Type
                            </th>
                            <th style={{ width: "10%" }} className="f12-500">
                              Event <br /> Value
                            </th>
                            <th style={{ width: "10%" }} className="f12-500">
                              Net Event <br /> Value
                            </th>
                            <th style={{ width: "10%" }} className="f12-500">
                              Taxes
                            </th>
                            <th style={{ width: "14%" }} className="f12-500">
                              Outgoing <br /> charges + GST
                            </th>
                            <th style={{ width: "14%" }} className="f12-500">
                              Commission <br />+ GST
                            </th>
                            <th style={{ width: "14%" }} className="f12-500">
                              Amount to be
                              <br />
                              Settled
                            </th>
                            <th style={{ width: "12%" }} className="f12-500">
                              Attended Date
                            </th>
                          </tr>
                        ) : null
                      }
                      displayscanpay={
                        state === 3 ? (
                          <tr>
                            <th style={{ width: "15%" }} className="f12-500">
                              Payment Method/ <br />
                              Transaction ID
                            </th>
                            <th style={{ width: "15%" }} className="f12-500">
                              User
                            </th>
                            <th style={{ width: "15%" }} className="f12-500">
                              Total
                              <br />
                              Amount
                            </th>
                            <th style={{ width: "10%" }} className="f12-500">
                              Tip
                            </th>
                            <th style={{ width: "10%" }} className="f12-500">
                              Donation
                            </th>

                            <th style={{ width: "15%" }} className="f12-500">
                              Payment Status
                              <br />
                              /Date & Time
                            </th>
                            <th
                              style={{ width: "15%" }}
                              className="f12-500"
                            ></th>
                          </tr>
                        ) : null
                      }
                    />
                  </thead>
                  {/* {state === 0
                    ? vendorEarningsData && vendorEarningsData?.order_id.map((order, index) => {
                        return (
                          <React.Fragment key={index}>
                            <TableBody />
                          </React.Fragment>
                        );
                      })
                    : null} */}
                  {vendorEarningsData?.payout_type === 0 ||
                  vendorEarningsData?.payout_type === 1 ? (
                    props.auth.secondary_loader ? (
                      <SmallLoader />
                    ) : (
                      !isEmpty(
                        vendorEarningsData && vendorEarningsData.order_id
                      ) &&
                      vendorEarningsData.order_id.map((order, index) => (
                        <TableBody
                          orderData={order}
                          comissionCode={vendorEarningsData?.restaurant_id?.comissionCode}
                          key={index}
                          loader={props.auth.loader}
                        />
                      ))
                    )
                  ) : null}
                  {vendorEarningsData?.payout_type === 2 ? (
                    props.auth.secondary_loader ? (
                      <SmallLoader />
                    ) : (
                      !isEmpty(
                        vendorEarningsData &&
                          vendorEarningsData.event_request_id
                      ) &&
                      vendorEarningsData.event_request_id.map((data, index) => (
                        <TableBodyEvents
                          eventData={data}
                          comissionCode={
                            vendorEarningsData?.restaurant_id?.comissionCode
                          }
                          key={index}
                          loader={props.auth.loader}
                        />
                      ))
                    )
                  ) : null}
                </Table>
              </div>
            </div>
          </div>
          <div className="bottom-panel"></div>
        </Row>
      </div>
    </React.Fragment>
  );
};

const TableBody = (props) => {
  const [TrDetail, setTrDetail] = useState({ TrDetail: false });
  const showTr = () => setTrDetail({ TrDetail: !TrDetail.TrDetail });

  const calcTaxes = (data) => {
    let tax = 0;
    if (!isEmpty(data)) {
      tax = Object.values(data).reduce(
        (a, b) => parseFloat(a) + parseFloat(b),
        0
      );
    }
    return tax.toFixed(2);
  };

  const calcTotalPayAmount = (transactionDetails) => {
    let payAmount = 0;
    transactionDetails.forEach((ele) => {
      if (ele.paid && ele.method === "RAZORPAY" && ele.type === "PAYMENT") {
        payAmount += ele.amount;
      }
    });
    return payAmount;
  };

  const amountToSettle = (data) => {
    let orderPayAmount = 0;
    let gatewayCharges =
      (data?.gatewayCharges?.fee || 0) + (data?.gatewayCharges?.tax || 0);
    let donation =
      data.donation && data.donation.amount ? data.donation.amount : 0;
    let payAmount = data.settleAmount ? data.settleAmount : data.total_amount;
    let comission = orderComission(data, props?.comissionCode);
    if (payAmount) {
      orderPayAmount += payAmount - donation - gatewayCharges - comission;
      return orderPayAmount;
    } else {
      return orderPayAmount;
    }
  };

  const orderComission = (order, comissionCode) => {
    let comission = parseFloat(comissionCode?.description || 0);
    let value =
      ((order?.base_amount -
        (order?.offerSettlement === "ADMIN"
          ? 0
          : order?.discount?.amount || 0)) *
        comission) /
      100;
    let gst = (value * 18) / 100;
    return value + gst;
  };

  const orderComssionDetails = (order, comissionCode) => {
    let comission = parseFloat(comissionCode?.description || 0);
    let value = (
      ((order?.base_amount -
        (order?.offerSettlement === "ADMIN"
          ? 0
          : order?.discount?.amount || 0)) *
        comission) /
      100
    ).toFixed(2);
    let gst = ((value * 18) / 100).toFixed(2);
    return { fee: value, gst: gst };
  };

  // const calcRazorpayCharges = (data) => {
  //   let transDetails = data.transactionDetails;
  //   let razorpayAmount = 0;
  //   transDetails.forEach((ele) => {
  //     if (ele.paid && ele.method === "RAZORPAY" && ele.type === "PAYMENT") {
  //       razorpayAmount += ele.amount;
  //     }
  //   });
  //   if (data.donation?.amount && razorpayAmount) {
  //     razorpayAmount = razorpayAmount - data.donation?.amount;
  //   }
  //   razorpayAmount = (razorpayAmount * 2) / 100;
  //   let tax = (razorpayAmount * 18) / 100;

  //   return (razorpayAmount + tax).toFixed(2);
  // };
  // console.log('Order');
  return (
    <tbody
      className="w-100 super-admin-all-vendor-main-table-body"
      style={{ fontSize: "12px", backgroundColor: "#ffffff" }}
    >
      <tr className="w-100 p-0">
        <td className="p-0 w-100">
          <table className="w-100">
            <tbody className="sd_body_css">
              <tr
                className={` cursor enGrayBorderBox sd_body_tr`}
                style={{
                  borderLeftWidth: "4px",
                  borderLeftStyle: "solid",
                  borderLeftColor: `${
                    props.orderData?.blockSettlement ? "#EE3A23" : "#06A200"
                  }`,
                }}
                onClick={showTr}
              >
                <td style={{ width: "12%" }}>
                  <div className="f12-500 text-break pl-3">
                    {props.orderData && props.orderData.order_type === 0
                      ? "Take Away"
                      : props.orderData && props.orderData.order_type === 1
                      ? "Curb Side"
                      : props.orderData && props.orderData.order_type === 3
                      ? "Dine-In"
                      : "Skip The Line"}
                    <br />
                    {props && props.orderData && props.orderData.order_id}
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="f12-500">
                    ₹ {props?.orderData?.base_amount?.toFixed(2) || 0}
                  </div>

                </td>
                <td style={{ width: "12%" }}>
                  <div className="f12-500">
                    - ₹ {props?.orderData?.discount?.amount.toFixed(2) || 0}
                  </div>
                </td>

                <td style={{ width: "12%" }}>
                  <div className="f12-500">
                    ₹{" "}
                    {(
                      (props?.orderData?.base_amount || 0) -
                      (props?.orderData?.discount?.amount || 0)
                    ).toFixed(2) || 0}
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500 d-flex">
                      ₹{calcTaxes(props.orderData.gstAmount)}
                    </div>
                    <InfoToolTip
                      title={"View the bifurcation of Taxes"}
                      data={props.orderData.gstAmount}
                    />
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500">
                      ₹ {calcTaxes(props.orderData.surCharges)}
                    </div>
                    <InfoToolTip
                      title={"View the bifurcation of Surcharges"}
                      data={props.orderData.surCharges}
                    />
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="f12-500">
                    ₹ {props?.orderData?.tip?.amount || 0}
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="f12-500">
                    ₹ {props?.orderData?.total_amount?.toFixed(2) || 0}
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500">
                      ₹{" "}
                      {(
                        parseFloat(
                          props?.orderData?.outgoingCharges?.fee || 0
                        ) +
                        parseFloat(props?.orderData?.outgoingCharges?.tax || 0)
                      ).toFixed(2)}
                    </div>
                    <InfoToolTip
                      title={"Outgoing gateway charges + GST"}
                      data={props.orderData.outgoingCharges}
                    />
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500">
                      ₹{" "}
                      {orderComission(
                        props.orderData,
                        props?.comissionCode
                      ).toFixed(2)}
                    </div>
                    <InfoToolTip
                      title={"Comission Charges + 18% GST"}
                      data={orderComssionDetails(
                        props.orderData,
                        props?.comissionCode
                      )}
                    />
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  <div className="f12-500">
                    ₹ {amountToSettle(props.orderData).toFixed(2)}
                  </div>
                </td>
              </tr>
              {TrDetail.TrDetail && (
                <>
                  <tr
                    className="sd_accordion_body"
                    style={{ background: "#ffffff" }}
                  >
                    <div className="container-fluid">
                      <div className="row d-flex justify-content-between">
                        <div className="f12-500">
                          <div>Dispute Id</div>
                          <div className="mt-3">N/A</div>
                        </div>
                        <div className="f12-500">
                          Disputed Amount
                          <div className="mt-3">₹ 0</div>
                        </div>
                        <div className="f12-500">
                          Disputed Items
                          <div className="mt-3">N/A</div>
                        </div>
                        <div className="f12-500">
                          Disputed Status
                          <div className="mt-3">N/A</div>
                        </div>
                        <div className="f12-500">
                          Due Date
                          <div className="mt-3">
                            {moment(props.orderData?.settleAfter)
                              .add(1, "day")
                              .format("MM-DD-YYYY")}
                            <br />
                            {moment(props.orderData?.settleAfter)
                              .add(1, "day")
                              .format("LT")}
                          </div>
                        </div>
                        <div className="f12-500">
                          No of Items
                          <div className="mt-3">
                            {props?.orderData?.order_items?.length}
                          </div>
                        </div>
                        <div className="f12-500">
                          Offer Type
                          <div className="mt-3">
                            {props?.orderData?.offerSettlement === "ADMIN"
                              ? "Amealio Offer"
                              : props?.orderData?.discount?.amount
                              ? "Merchant Offer"
                              : "N/A"}
                          </div>
                        </div>
                        <div className="f12-500">
                          Order Date
                          <div className="mt-3">
                            {" "}
                            {moment(props.orderData?.createdAt).format(
                              "MM-DD-YYYY"
                            )}
                            <br />
                            {moment(props.orderData?.createdAt).format("LT")}
                          </div>
                        </div>
                        <div className="f12-500">
                          Payment Block
                          <div className="mt-3">
                            {props?.orderData?.blockReason || "-"}
                          </div>
                        </div>
                        <div className="f10-400 m-2" align="center">
                          <img
                            src={require("../../../assets/images/iconButton/eye.png")}
                            width="35px"
                            alt="icon"
                          />
                          <br />
                          View <br /> Dispute
                        </div>
                        <div className="f10-400 m-2" align="center">
                          <img
                            src={require("../../../assets/images/iconButton/eye.png")}
                            width="35px"
                            alt="icon"
                          />
                          <br />
                          View <br /> Transaction
                        </div>
                      </div>
                    </div>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};

PayoutHistory.propTypes = {
  auth: PropTypes.object.isRequired,
  get_all_history_earnings: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  getAllVendorPayoutHistoryData: state.vendorEarnings.get_all_history_earnings,
});

export default connect(mapStateToProps, {
  get_all_history_earnings,
})(PayoutHistory);

const TableHead = (props) => {
  return (
    <>
      {props?.display}
      {props?.displayevents}
      {props?.displayscanpay}
    </>
  );
};

const TableBodyEvents = (props) => {
  const [TrDetail, setTrDetail] = useState({ TrDetail: false });
  const showTr = () => setTrDetail({ TrDetail: !TrDetail.TrDetail });
  const [data, setData] = useState({});

  const eventComission = (event, comissionCode) => {
    let comission = parseFloat(comissionCode?.description || 0);
    let value = (event?.payment_data?.total_amount * comission) / 100;
    let gst = (value * 18) / 100;
    return value + gst;
  };

  const eventComssionDetails = (event, comissionCode) => {
    let comission = parseFloat(comissionCode?.description || 0);
    let value = ((event?.payment_data?.total_amount * comission) / 100).toFixed(
      2
    );
    let gst = ((value * 18) / 100).toFixed(2);
    return { fee: value, gst: gst };
  };

  const amountToSettle = (data) => {
    let orderPayAmount = 0;
    let gatewayCharges =
      (data?.outgoingCharges?.fee || 0) + (data?.outgoingCharges?.tax || 0);
    let donation = Number(data?.payment_data?.donate_amount || 0);
    let payAmount = Number(data?.payment_data?.total_amount);
    let comission = eventComission(data, props?.comissionCode);
    if (payAmount) {
      orderPayAmount += payAmount - donation - gatewayCharges - comission;
      return orderPayAmount;
    } else {
      return orderPayAmount;
    }
  };

  useEffect(() => {
    let comission = eventComission(
      props.eventData,
      props?.comissionCode
    ).toFixed(2);
    let settle = amountToSettle(props.eventData).toFixed(2);
    let comissionDetails = eventComssionDetails(
      props.eventData,
      props?.comissionCode
    );
    setData({ comission, settle, comissionDetails });
  }, [props]);

  return (
    <tbody
      className="w-100 super-admin-all-vendor-main-table-body"
      style={{ fontSize: "12px", backgroundColor: "#ffffff" }}
    >
      <tr className="w-100 p-0">
        <td className="p-0 w-100">
          <table className="w-100">
            <tbody className="sd_body_css">
              <tr
                style={{
                  borderLeftWidth: "4px",
                  borderLeftStyle: "solid",
                  borderLeftColor: `${
                    props.eventData?.blockSettlement ? "#EE3A23" : "#06A200"
                  }`,
                }}
                onClick={showTr}
              >
                {/* // TODO Need to Maintain ENUM */}
                <td style={{ width: "14%" }}>
                  <div className="d-flex align-items-center ml-4">
                    <div className="f12-500 text-break">
                      {props?.eventData?.event?.name}
                      <br />
                      {props?.eventData?.event?.event_id}
                      <br />
                      {props?.eventData?.event_type === "TICKET_BOOKED"
                        ? "Ticket Booking"
                        : "RSVP"}
                    </div>
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500 ml-3">
                      {props?.eventData?.payment_data?.total_amount || 0}
                    </div>
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500 ml-3">
                      {props?.eventData?.payment_data?.tax_charge || 0}
                    </div>
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500 ml-3">
                      {props?.eventData?.payment_data?.tax_charge || 0}
                    </div>
                  </div>
                </td>
                <td style={{ width: "14%" }}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500">
                      ₹{" "}
                      {(
                        parseFloat(
                          props?.eventData?.outgoingCharges?.fee || 0
                        ) +
                        parseFloat(props?.eventData?.outgoingCharges?.tax || 0)
                      ).toFixed(2)}
                    </div>
                    <InfoToolTip
                      title={"Outgoing gateway charges 2% + 18% GST"}
                      data={props?.eventData.outgoingCharges}
                    />
                  </div>
                </td>
                <td style={{ width: "14%" }}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500">₹ {data?.comission}</div>
                    <InfoToolTip
                      title={"Comission + 18% GST"}
                      data={data?.comissionDetails}
                    />
                  </div>
                </td>
                <td style={{ width: "14%" }}>
                  <div className="d-flex align-items-center">
                    <div className="f12-500 ml-3">{data.settle}</div>
                  </div>
                </td>
                <td style={{ width: "12%" }}>
                  {moment(props?.eventData?.createdAt).format("MM-DD-YYYY")}
                  <br /> {moment(props?.eventData?.createdAt).format("LT")}
                </td>
              </tr>
              {TrDetail.TrDetail && (
                <>
                  <tr
                    className="sd_accordion_body"
                    style={{ background: "#ffffff" }}
                  >
                    <div className="container-fluid">
                      <div className="row d-flex justify-content-between">
                        {props.eventData?.disputeId && (
                          <>
                            <div className="f12-500">
                              <div>Dispute Id</div>
                              <div className="mt-3">N/A</div>
                            </div>
                            <div className="f12-500">
                              Disputed Amount
                              <div className="mt-3">₹ 0</div>
                            </div>
                            <div className="f12-500">
                              Disputed Items
                              <div className="mt-3">N/A</div>
                            </div>
                            <div className="f12-500">
                              Disputed Status
                              <div className="mt-3">N/A</div>
                            </div>
                          </>
                        )}
                        <div className="f12-500">
                          Due Date
                          <div className="mt-3">
                            {moment(props.eventData?.settleAfter)
                              .add(1, "day")
                              .format("MM-DD-YYYY")}
                            <br />
                            {moment(props.eventData?.settleAfter)
                              .add(1, "day")
                              .format("LT")}
                          </div>
                        </div>
                        <div className="f12-500">
                          Total PAX <br /> Ticket No.
                          <div className="mt-3">
                            {props?.eventData?.adult_count ||
                              0 + props?.eventData?.kids_count ||
                              0}{" "}
                            <br /> {props?.eventData?.event_request_id}
                          </div>
                        </div>
                        <div className="f12-500">
                          Payment Block
                          <div className="mt-3">
                            {props?.eventData?.blockReason || "-"}
                          </div>
                        </div>
                      </div>
                    </div>
                  </tr>
                  <tr
                    className="sd_accordion_body"
                    style={{ background: "#ffffff" }}
                  >
                    <div className="container-fluid">
                      <div className="row d-flex justify-content-between">
                        <div className="f12-500">
                          <div>Payout Payment Method</div>
                          <div className="mt-3">{NEFT}</div>
                        </div>
                        <div className="f12-500">
                          Payment Terms
                          <div className="mt-3">T2</div>
                        </div>
                        <div className="f12-500">
                          Incoming Gateway Charges + GST
                          <div className="d-flex align-items-center mt-3">
                            <div>
                              ₹{" "}
                              {(props?.eventData?.gatewayCharges?.fee || 0) +
                                (props?.eventData?.gatewayCharges?.tax || 0)}
                            </div>
                            <InfoToolTip
                              title={"Incoming gateway charges + Taxes"}
                              data={props.eventData.gatewayCharges}
                            />
                          </div>
                        </div>
                        <div className="f12-500">
                          Donation
                          <div className="mt-3">
                            ₹{" "}
                            {props?.eventData?.payment_data?.donate_amount || 0}
                          </div>
                        </div>
                        <div className="f12-500">
                          <div className="d-flex justify-content-around">
                            {props.eventData?.disputeId && (
                              <div className="f10-400 m-2" align="center">
                                <img
                                  src={require("../../../assets/images/iconButton/eye.png")}
                                  width="35px"
                                  alt="icon"
                                />
                                <br />
                                View <br /> Dispute
                              </div>
                            )}
                            {/* <div className="f10-400 m-2" align="center" onClick={() => props.handleShowClear(props.orderData)} style={{ cursor: "pointer" }}>
                              <img
                                src={require("../../../../assets/images/iconButton/Reset.svg")}
                                width="35px"
                                alt="icon"
                              />
                              <br />
                              Reset <br /> to Clear
                            </div> */}
                            <div className="f10-400 m-2" align="center">
                              <img
                                src={require("../../../assets/images/iconButton/eye.png")}
                                width="35px"
                                alt="icon"
                              />
                              <br />
                              View <br /> Transaction
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};
